/**
 * Add item to cart based on variant ID
 * @param {Array} items
 * @returns {object} cart
 */
const addToCart = async (items) => {
  const formData = {
    items,
    sections: 'header,cart-drawer,main-cart,footer',
  };
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    const parsedResponse = await response.json();

    const cartDrawerCountChatters = document.querySelector(
      '[data-cart-drawer-count-chatters]'
    );
    if (cartDrawerCountChatters) {
      if (parsedResponse.items && parsedResponse.items.length > 0) {
        cartDrawerCountChatters.classList.remove('hidden');
      } else {
        cartDrawerCountChatters.classList.add('hidden');
      }
    }

    if (parsedResponse.sections) {
      const { header, 'cart-drawer': cartDrawer } = parsedResponse.sections;
      // update cart
      updateCartDrawerContent(cartDrawer);
    } else {
      // process the error and show it to the user
      document.dispatchEvent(new CustomEvent('cart:open'));
      const event = new CustomEvent('cart:error', {
        detail: parsedResponse.description || parsedResponse.message,
      });
      document.dispatchEvent(event);
    }
  } catch (error) {
    console.error('Error:', error);
  }
};

/**
 * Get cart content when we need the cart content without adding, updating or deleting items
 * @param {function} callback
 * @returns {object} cart
 */

const getCart = async () => {
  try {
    const response = await fetch(
      window.Shopify.routes.root +
        '?sections=header,cart-drawer,main-cart,footer',
      {
        method: 'GET',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    const parsedResponse = await response.json();

    if (parsedResponse) {
      const { header, 'cart-drawer': cartDrawer } = parsedResponse;
      // update cart
      updateCartDrawerContent(cartDrawer);
    } else {
      // process the error and show it to the user
      document.dispatchEvent(new CustomEvent('cart:open'));
      const event = new CustomEvent('cart:error', {
        detail: parsedResponse.description || parsedResponse.message,
      });
      document.dispatchEvent(event);
    }
    document.dispatchEvent(new CustomEvent('cart:open'));
  } catch (error) {
    console.error('Error:', error);
  }
};

/**
 * Change cart item
 * @param {string} key - can either be line item key or variant ID
 * @param {number} quantity
 * @param {function} callback
 * @returns {object} cart
 */
const changeItem = ({ key, quantity, properties, callback, mainCart = false }) =>
  new Promise((resolve) => {
    const formData = {
      id: key,
      quantity,
      properties,
      sections: mainCart ? 'main-cart' : 'header,cart-drawer,footer',
    };

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then(async (cart) => {
        if (cart.sections) {
          if (mainCart) {
            const {
              'main-cart': mainCart
            } = cart.sections;

            // update cart count
            updateMainCartContent(mainCart);
          } else {
            const {
              header,
              'cart-drawer': cartDrawer,
              // 'main-cart': mainCart,
            } = cart.sections;

            // update cart count
            updateCartDrawerContent(cartDrawer);
          }
        } else {
          // process the error and show it to the user
          const event = new CustomEvent('cart:error', {
            detail: cart.description || cart.message,
          });
          document.dispatchEvent(event);
        }
        return {
          response: cart,
        };
      })
      .then(({ response }) => {
        const failedIncrease = response.status === 422 ? key : null;

        if (callback) {
          callback(response);
        }

        resolve(response);
      });
  });

const updateMainCartContent = (mainCart) => {
  const parser = new DOMParser();
  const mainCartElement = parser.parseFromString(mainCart, 'text/html');
  let isEmptyCart = false;

  const mainCartItems = document.querySelector(
    '[data-main-cart-items]'
  );
  if (mainCartItems) {
    mainCartItems.innerHTML = mainCartElement.querySelector(
      '[data-main-cart-items]'
    ).innerHTML;
    if (mainCartItems.innerHTML.length < 100) {
      isEmptyCart = true;
    }
  }

  const mainCartTotal = document.querySelector(
    '[data-main-cart-total]'
  );
  if (mainCartTotal) {
    mainCartTotal.innerHTML = mainCartElement.querySelector(
      '[data-main-cart-total]'
    ).innerHTML;
  }

  const mainCartContinueShopping = document.querySelector(
    '[data-main-cart-continue-shopping]'
  );


  if (mainCartContinueShopping) {
    mainCartContinueShopping.innerHTML = mainCartElement.querySelector(
      '[data-main-cart-continue-shopping]'
    ).innerHTML;
  }

  const mainCartTitle = document.querySelector(
    '[data-main-cart-title]'
  );
  if (mainCartTitle) {
    mainCartTitle.innerHTML = mainCartElement.querySelector(
      '[data-main-cart-title]'
    ).innerHTML;
  }

  let checkoutChatters = document.querySelector(
    '[data-checkout-chatters]'
  );
  if (checkoutChatters) {
    if (isEmptyCart) {
      checkoutChatters.classList.add('hidden');
    }
  }

  const customerAddresses = document.querySelector(
    '[data-customer-addresses]'
  );
  if (customerAddresses) {
    if (isEmptyCart) {
      customerAddresses.classList.add('hidden');
    }
  }

  const placeHolderButton = document.querySelector(
    '[data-place-holder-button]'
  );
  if (placeHolderButton) {
    if (isEmptyCart) {
      placeHolderButton.classList.add('hidden');
    }
  }

  const placeHolderChatters = document.querySelector(
    '[data-place-order-chatters]'
  );
  if (placeHolderChatters) {
    if (isEmptyCart) {
      placeHolderChatters.classList.add('hidden');
    }
  }

  const lineItemsData = document.querySelector(
    '[data-line-items-data]'
  );
  if (lineItemsData) {
    lineItemsData.dataset.lineItemsData = mainCartElement.querySelector(
      '[data-line-items-data]'
    )?.dataset.lineItemsData ? mainCartElement.querySelector(
      '[data-line-items-data]'
    ).dataset.lineItemsData : '';
  }

    // Emit custom event to reattach event listeners
    const event = new CustomEvent('main-cart:attachListener');
    document.dispatchEvent(event);
}

const updateCartDrawerContent = (cartDrawer) => {
  const parser = new DOMParser();
  const cartDrawerElement = parser.parseFromString(cartDrawer, 'text/html');

  const cartDrawerCount = document.querySelector('[data-cart-drawer-count]');
  cartDrawerCount.textContent = cartDrawerElement
    ? cartDrawerElement.querySelector('[data-cart-drawer-count]').textContent
    : '';

  // update cart content
  const cartDrawerContent = document.querySelector(
    '[data-cart-drawer-content]'
  );
  if (cartDrawerContent) {
    cartDrawerContent.innerHTML = cartDrawerElement.querySelector(
      '[data-cart-drawer-content]'
    ).innerHTML;
  }

  // update cart footer
  const cartDrawerFooter = document.querySelector('[data-cart-drawer-footer]');
  if (cartDrawerFooter) {
    cartDrawerFooter.innerHTML = cartDrawerElement.querySelector(
      '[data-cart-drawer-footer]'
    ).innerHTML;
  }

  // Emit custom event to reattach event listeners
  const event = new CustomEvent('cart:attachListener');
  document.dispatchEvent(event);

  // Emit custom event to get the new recommendations
  const eventBuyItWith = new CustomEvent('buy-it-with:load-recommendations');
  document.dispatchEvent(eventBuyItWith);
};

export { addToCart, changeItem, getCart };
